import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
console.log(messages)
const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})
export default i18n
